/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import './optimiseroutes_new.css';
import { getHyphenYYYYMMDDHHMMSS } from '../common/utils';
import { gMap } from '../../config/googleMaps';

var redirectURL = require('../redirectURL');
var { exportToExcel, exportToCsv } = require('./exportUtils');

var _currentYear = new Date().getFullYear();
var YEAR_OPTIONS = [];
for (var _y = _currentYear - 3; _y <= _currentYear + 1; _y++) {
    YEAR_OPTIONS.push({ label: String(_y), value: String(_y) });
}

var QUARTER_OPTIONS = [
    { label: "Q1", value: "Q1" },
    { label: "Q2", value: "Q2" },
    { label: "Q3", value: "Q3" },
    { label: "Q4", value: "Q4" },
];

// Maps state codes (case-insensitive) to their full display names.
// Value sent in payload stays as the raw code from the API.
var STATE_CODE_MAP = {
    "AN": "Andaman & Nicobar",
    "AP": "Andhra Pradesh",
    "ARP": "Arunachal Pradesh",
    "AS": "Assam",
    "BH": "Bihar",
    "CD": "Chandigarh",
    "CG": "Chhattisgarh",
    "DEL": "Delhi",
    "DH": "Dadra & Nagar Haveli",
    "GDD": "Goa",
    "GJ": "Gujarat",
    "HP": "Himachal Pradesh",
    "HR": "Haryana",
    "JK": "Jammu & Kashmir",
    "JR": "Jharkhand",
    "KAR": "Karnataka",
    "KER": "Kerala",
    "LDK": "Ladakh",
    "MAH": "Maharashtra",
    "MGH": "Meghalaya",
    "MP": "Madhya Pradesh",
    "MPR": "Manipur",
    "MZ": "Mizoram",
    "NG": "Nagaland",
    "OR": "Odisha",
    "PB": "Punjab",
    "PY": "Puducherry",
    "RJ": "Rajasthan",
    "TLG": "Telangana",
    "TN": "Tamil Nadu",
    "TRI": "Tripura",
    "UK": "Uttarakhand",
    "UP": "Uttar Pradesh",
    "UR": "Uttarakhand",
    "WB": "West Bengal",
};

function buildStateOptions(codes) {
    var seen = {};
    var opts = [{ label: "ALL", value: "ALL" }];
    (codes || []).forEach(function (code) {
        if (!code || typeof code !== "string") return;
        var key = code.trim().toUpperCase();
        if (!key || key === "ALL") return;
        if (seen[key]) return; // deduplicate by code
        seen[key] = true;
        var label = STATE_CODE_MAP[key] || code.trim();
        opts.push({ label: label, value: code.trim() });
    });
    return opts;
}

function safeParse(value) {
    try {
        if (!value || value === "undefined" || value === "null") return [];
        if (Array.isArray(value)) return value;
        return JSON.parse(value);
    } catch (e) {
        return [];
    }
}

function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0];
    var script = window.document.createElement("script");
    script.src = url;
    script.async = true;
    script.defer = true;
    index.parentNode.insertBefore(script, index);
}

function ptsFromArray(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.map(function (p) {
        return {
            lat: parseFloat(p.lat !== undefined ? p.lat : p.latitude),
            lng: parseFloat(p.lng !== undefined ? p.lng : p.longitude),
        };
    }).filter(function (p) { return !isNaN(p.lat) && !isNaN(p.lng); });
}

var ROUTE_COLORS = ['#2c7be5', '#e74c3c', '#28a745', '#e67e22', '#8e44ad',
    '#16a085', '#d63384', '#f39c12', '#0dcaf0', '#6610f2'];

var SIDE_BAR_DEF = {
    toolPanels: [
        {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
        },
        {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
        },
    ],
};

export default function RouteAnalysisDashboardReport(props) {
    // ── Loader / alert state ──────────────────────────────────────────────────
    var [loadshow, setLoadshow] = useState('show-n');
    var [overly, setOverly] = useState('show-n');
    var [show, setShow] = useState(false);
    var [basicTitle, setBasicTitle] = useState('');
    var [basicType, setBasicType] = useState('default');

    // ── Dept code ─────────────────────────────────────────────────────────────
    var [dept_code, setDeptCode] = useState('SNDG');

    // ── Dropdown option lists ─────────────────────────────────────────────────
    var [originoptions, setOriginoptions] = useState([{ label: "ALL", value: "ALL" }]);
    var [destinationOptions, setDestinationOptions] = useState([{ label: "ALL", value: "ALL" }]);
    var [truck_types, setTruckTypes] = useState([{ label: "ALL", value: "ALL" }]);
    var [zonesOptions, setZonesOptions] = useState([{ label: "ALL", value: "ALL" }]);
    var [consignee_state_options, setConsigneeStateOptions] = useState([{ label: "ALL", value: "ALL" }]);

    // ── Selected filter values ─────────────────────────────────────────────────
    var [originoption, setOriginoption] = useState({ label: "ALL", value: "ALL" });
    var [destinationoption, setDestinationoption] = useState({ label: "ALL", value: "ALL" });
    var [selected_truck_type, setSelectedTruckType] = useState({ label: "ALL", value: "ALL" });
    var [selectedZone, setSelectedZone] = useState({ label: "ALL", value: "ALL" });
    var [selectedConsState, setSelectedConsState] = useState({ label: "ALL", value: "ALL" });

    // ── Year / Quarter / Custom Date Range ────────────────────────────────────
    var [selected_year, setSelectedYear] = useState({ label: String(_currentYear), value: String(_currentYear) });
    var [selected_quarter, setSelectedQuarter] = useState({ label: "Q1", value: "Q1" });
    var [use_custom_date_range, setUseCustomDateRange] = useState(false);
    var [from_date, setFromDate] = useState('');
    var [to_date, setToDate] = useState('');

    // ── Grid row data ─────────────────────────────────────────────────────────
    var [rowData, setRowData] = useState([]);
    var [routeLabels, setRouteLabels] = useState([]);

    var [sliderTranslate, setSliderTranslate] = useState('');
    var [sliderMode, setSliderMode] = useState('grid');   // 'grid' | 'map'
    var [sliderTitle, setSliderTitle] = useState('');
    var [sliderTrips, setSliderTrips] = useState([]);
    var [mapLegend, setMapLegend] = useState([]);

    var gridApiRef = useRef(null);
    var plantNameRef = useRef({});
    var mapScriptLoaded = useRef(false);
    var mapDivRef = useRef(null);
    var mapInstanceRef = useRef(null);
    var mapOverlaysRef = useRef([]);
    var mapToken = useRef(0);
    var routeGroupsRef = useRef([]);
    var gridTitleRef = useRef('');

    var defaultColDef = useMemo(function () {
        return { sortable: true, filter: true, resizable: true, autoHeight: true, width: 130 };
    }, []);

    // ── Initial data load ─────────────────────────────────────────────────────
    useEffect(function () {
        var dcCode = 'SNDG';
        setDeptCode(dcCode);
        setLoadshow("show-m");
        setOverly("show-m");

        redirectURL.post("/consignments/get_plants_mapping", { dept_code: dcCode })
            .then(function (res) {
                var nameMap = {};
                (res.data || []).forEach(function (p) {
                    if (!p || !p.plant_code) return;
                    nameMap[p.plant_code] = p.plant_name || p.plant_code;
                });
                plantNameRef.current = nameMap;
                return redirectURL.post("/dashboard/getSourceFromBaseRoutes", { dept_code: dcCode });
            })
            .then(function (res) {
                var names = plantNameRef.current || {};
                var originopts = [{ label: "ALL", value: "ALL" }];
                (res.data || []).forEach(function (item) {
                    if (!item || item.toUpperCase() === "ALL") return;
                    if (!names[item]) return;
                    originopts.push({ value: item, label: names[item] });
                });
                setOriginoptions(originopts);
                return redirectURL.post("dashboard/getDestinationFromRouteAnalytics", { consigner_code: "", dept_code: dcCode });
            })
            .then(function (res) {
                var destOpts = [{ label: "ALL", value: "ALL" }];
                (res.data || []).forEach(function (item) {
                    if (item && item.toUpperCase() !== "ALL") {
                        destOpts.push({ value: item, label: item });
                    }
                });
                setDestinationOptions(destOpts);
                return redirectURL.post("dashboard/getDropDownForBaseRouteOptimisedNew", { dept_code: dcCode });
            })
            .then(function (res) {
                var data = res.data || {};

                var truckOpts = [{ label: "ALL", value: "ALL" }];
                (data.truck_types || []).forEach(function (e) {
                    if (e && e.toUpperCase() !== "ALL") { truckOpts.push({ label: e, value: e }); }
                });
                setTruckTypes(truckOpts);

                var zoneOpts = [{ label: "ALL", value: "ALL" }];
                (data.zones || []).forEach(function (e) {
                    if (e && e.toUpperCase() !== "ALL") { zoneOpts.push({ label: e, value: e }); }
                });
                setZonesOptions(zoneOpts);

                setConsigneeStateOptions(buildStateOptions(data.consignee_state));

                setLoadshow("show-n");
                setOverly("show-n");
            })
            .catch(function (err) {
                console.error("Initial data load failed", err);
                setLoadshow("show-n");
                setOverly("show-n");
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Build query from current filter state ─────────────────────────────────
    var buildQuery = useCallback(function () {
        var query = {
            truck_type: selected_truck_type.value,
            period_type: "ALL",
        };

        if (use_custom_date_range) {
            if (from_date) query.from_date = from_date;
            if (to_date) query.to_date = to_date;
        } else {
            query.quarter = selected_year.value + "-" + selected_quarter.value;
        }

        if (originoption.value && originoption.value !== "ALL") {
            query.sl_codes = [originoption.value];
        }
        if (destinationoption.value && destinationoption.value !== "ALL") {
            query.dl_city = destinationoption.value;
        }
        if (selectedConsState.value && selectedConsState.value !== "ALL") {
            query.dl_state = selectedConsState.value;
        }
        if (selectedZone.value && selectedZone.value !== "ALL") {
            query.zone = selectedZone.value;
        }

        return query;
    }, [use_custom_date_range, from_date, to_date, selected_year, selected_quarter,
        selected_truck_type, originoption, destinationoption, selectedConsState, selectedZone]);

    // ── Fetch data ────────────────────────────────────────────────────────────
    var fetchData = useCallback(function () {
        setLoadshow("show-m");
        setOverly("show-m");

        redirectURL.post("/dashboard/getRouteAnalysisDashboardReport", buildQuery())
            .then(function (response) {
                var payload = response.data || {};

                // Response shape: { data: [...], route_labels: [...] }
                var records = Array.isArray(payload.data) ? payload.data : [];
                var labels = Array.isArray(payload.route_labels) ? payload.route_labels : [];

                if (!records.length) {
                    setBasicTitle("No data found for the selected filters.");
                    setBasicType("warning");
                    setShow(true);
                    setRowData([]);
                    setRouteLabels([]);
                    setLoadshow("show-n");
                    setOverly("show-n");
                    return;
                }

                setRouteLabels(labels);
                setRowData(records);
                setLoadshow("show-n");
                setOverly("show-n");
            })
            .catch(function (err) {
                console.error("Route analysis dashboard report error:", err);
                setBasicTitle("Failed to fetch data. Please try again.");
                setBasicType("danger");
                setShow(true);
                setLoadshow("show-n");
                setOverly("show-n");
            });
    }, [buildQuery]);

    // ── Submit handler ────────────────────────────────────────────────────────
    var onSubmit = useCallback(function () {
        if (use_custom_date_range && from_date && to_date && from_date > to_date) {
            setBasicTitle("'From Date' must be earlier than or equal to 'To Date'.");
            setBasicType("warning");
            setShow(true);
            return;
        }
        fetchData();
    }, [use_custom_date_range, from_date, to_date, fetchData]);

    // ── Toggle custom date range ──────────────────────────────────────────────
    var toggleCustomDateRange = useCallback(function () {
        setUseCustomDateRange(function (prev) { return !prev; });
        setFromDate('');
        setToDate('');
    }, []);

    var onGridReady = function (params) { gridApiRef.current = params.api; };

    var onExportExcel = useCallback(function () {
        try {
            exportToExcel(
                gridApiRef.current,
                columnDefs,
                rowData,
                "Route_Analysis_Dashboard_Report.xlsx"
            );
        } catch (e) {
            console.error("Excel export failed:", e);
        }
    }, [columnDefs, rowData]);

    var onExportCsv = useCallback(function () {
        try {
            exportToCsv(
                gridApiRef.current,
                columnDefs,
                rowData,
                "Route_Analysis_Dashboard_Report.csv"
            );
        } catch (e) {
            console.error("CSV export failed:", e);
        }
    }, [columnDefs, rowData]);

    // ── Slider close / back handlers ─────────────────────────────────────────
    var onCloseSlider = useCallback(function () {
        mapToken.current += 1;
        routeGroupsRef.current = [];
        setSliderTranslate('');
        setSliderMode('grid');
        setMapLegend([]);
        setOverly('show-n');
    }, []);

    var onBackToGrid = useCallback(function () {
        mapToken.current += 1;
        routeGroupsRef.current = [];
        (mapOverlaysRef.current || []).forEach(function (o) {
            try { o.setMap(null); } catch (e) { /* noop */ }
        });
        mapOverlaysRef.current = [];
        setMapLegend([]);
        setSliderMode('grid');
        setSliderTitle(gridTitleRef.current || '');
        setSliderTranslate('slider-translate-60p');
    }, []);

    var onSliderCloseClick = useCallback(function () {
        if (sliderMode === 'map') onBackToGrid();
        else onCloseSlider();
    }, [sliderMode, onBackToGrid, onCloseSlider]);

    // ── Map rendering ─────────────────────────────────────────────────────────
    var plotRouteGroups = useCallback(function () {
        var el = mapDivRef.current || document.getElementById('radMap');
        if (!el || !el.isConnected || !window.google || !window.google.maps) return;

        var groups = routeGroupsRef.current || [];
        var map = mapInstanceRef.current;
        if (!map) {
            map = new window.google.maps.Map(el, {
                zoom: 7,
                center: new window.google.maps.LatLng(28.497236, 77.062363),
                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                mapTypeControl: true, fullscreenControl: true, zoomControl: true,
            });
            mapInstanceRef.current = map;
        }

        (mapOverlaysRef.current || []).forEach(function (o) {
            try { o.setMap(null); } catch (e) { /* noop */ }
        });
        mapOverlaysRef.current = [];

        var bounds = new window.google.maps.LatLngBounds();
        var any = false;

        groups.forEach(function (g) {
            if (g.coords && g.coords.length) {
                var path = g.coords.map(function (p) {
                    return new window.google.maps.LatLng(p.lat, p.lng);
                });
                path.forEach(function (pt) { bounds.extend(pt); any = true; });
                mapOverlaysRef.current.push(new window.google.maps.Polyline({
                    path: path, geodesic: true, strokeColor: g.color,
                    strokeOpacity: 0.9, strokeWeight: 4, map: map,
                }));
                mapOverlaysRef.current.push(new window.google.maps.Marker({ position: path[0], map: map, label: 'S', title: (g.label || '') + ' Start' }));
                mapOverlaysRef.current.push(new window.google.maps.Marker({ position: path[path.length - 1], map: map, label: 'E', title: (g.label || '') + ' End' }));
            }
            (g.markers || []).forEach(function (m) {
                if (isNaN(m.lat) || isNaN(m.lng)) return;
                var pos = new window.google.maps.LatLng(m.lat, m.lng);
                bounds.extend(pos); any = true;
                var opts = { position: pos, map: map, title: m.title || '' };
                if (m.kind === 'source' || m.kind === 'dest') {
                    opts.icon = {
                        path: window.google.maps.SymbolPath.CIRCLE, scale: 7,
                        fillColor: m.kind === 'source' ? '#28a745' : '#d6336c',
                        fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2,
                    };
                } else if (m.kind === 'break') {
                    opts.icon = {
                        path: window.google.maps.SymbolPath.CIRCLE, scale: 5,
                        fillColor: '#f39c12', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 1,
                    };
                }
                mapOverlaysRef.current.push(new window.google.maps.Marker(opts));
            });
        });

        window.google.maps.event.trigger(map, 'resize');
        if (any) { map.fitBounds(bounds); }
        else { map.setCenter(new window.google.maps.LatLng(28.497236, 77.062363)); map.setZoom(7); }
    }, []);

    var renderOrnMap = useCallback(function () {
        if (window.google && window.google.maps) { plotRouteGroups(); return; }
        window.initRadMap = plotRouteGroups;
        if (!mapScriptLoaded.current) {
            mapScriptLoaded.current = true;
            loadScript("https://maps.googleapis.com/maps/api/js?key=" + gMap.API_KEY
                + "&libraries=places,drawing,geometry&callback=initRadMap");
        }
    }, [plotRouteGroups]);

    var switchToMap = useCallback(function (title) {
        mapToken.current += 1;
        var myToken = mapToken.current;
        setMapLegend((routeGroupsRef.current || []).map(function (g) {
            return { label: g.label, color: g.color };
        }));
        setSliderMode('map');
        setSliderTitle(title);
        setSliderTranslate('slider-translate-75p');
        setLoadshow('show-n');
        setOverly('show-m');
        setTimeout(function () { if (myToken === mapToken.current) renderOrnMap(); }, 450);
    }, [renderOrnMap]);

    // ── Open trips slider ─────────────────────────────────────────────────────
    var onCellClicked = useCallback(function (params) {
        if (params.colDef.field !== 'valid_trips') return;
        var trips = (params.data && Array.isArray(params.data.trips)) ? params.data.trips : [];
        var src = (params.data && params.data.source) || '';
        var city = (params.data && params.data.city) || '';
        var title = 'Valid Trips' + (src ? ' — ' + src : '') + (city ? ' → ' + city : '');
        setSliderTrips(trips);
        setSliderTitle(title);
        gridTitleRef.current = title;
        setSliderMode('grid');
        setSliderTranslate('slider-translate-60p');
        setOverly('show-m');
    }, []);

    // ── Plot a single trip on the map (from trips slider grid) ────────────────
    var onTripCellClicked = useCallback(function (params) {
        if (!params.colDef || params.colDef.field !== '_rowmap') return;
        var r = params.data;
        if (!r) return;
        setLoadshow('show-m');
        setOverly('show-m');
        redirectURL.post('/consignments/maproutes', {
            truck_no: r.vehicle_no || '',
            gate_out_time: r.sl_exit_dt || '',
            seconddate: r.trip_end_time || '',
            consignment_code: r.invoice_no || '',
            consignee_code: r.dl_code || '',
            screen: 'consignment',
            source_screen: 'optimiseroutes',
            fetch_address: 0,
            dept_code: r.dept_code || dept_code,
        }).then(function (resp) {
            var d = resp.data;
            if (typeof d === 'string') { try { d = JSON.parse(d); } catch (e) { d = {}; } }
            d = d || {};
            var markers = [];
            if (d.consigner_coordinates && d.consigner_coordinates.lat !== undefined) {
                markers.push({ lat: parseFloat(d.consigner_coordinates.lat), lng: parseFloat(d.consigner_coordinates.lng), kind: 'source', title: 'Source: ' + (d.consigner_coordinates.name || '') });
            }
            if (d.consignee_coordinates && d.consignee_coordinates.lat !== undefined) {
                markers.push({ lat: parseFloat(d.consignee_coordinates.lat), lng: parseFloat(d.consignee_coordinates.lng), kind: 'dest', title: 'Dealer: ' + (d.consignee_coordinates.name || '') });
            }
            (d.breaks || []).forEach(function (b) {
                markers.push({ lat: parseFloat(b.lat), lng: parseFloat(b.lng), kind: 'break', title: 'Break' });
            });
            routeGroupsRef.current = [{
                label: (r.vehicle_no || '') + ' / ' + (r.invoice_no || ''),
                color: ROUTE_COLORS[0],
                coords: ptsFromArray(d.coords || []),
                markers: markers,
            }];
            var hasData = (d.coords && d.coords.length) || markers.length;
            switchToMap((r.vehicle_no || '') + ' — Route Map');
            if (!hasData) {
                setBasicTitle("No GPS data found for this trip.");
                setBasicType("info");
                setShow(true);
            }
        }).catch(function (err) {
            console.error("Trip map error:", err);
            setLoadshow('show-n');
            setOverly('show-n');
        });
    }, [dept_code, switchToMap]);

    var columnDefs = useMemo(function () {
        // Dynamic route sub-columns built from route_labels (R1, R2, … as returned by API).
        // Each array entry (avg_distances[i], follower_pcts[i], toll_amounts[i]) maps to label[i].
        var routeCols = function (arrayField, formatter) {
            return routeLabels.map(function (lbl, i) {
                return {
                    headerName: lbl,
                    width: 90,
                    valueGetter: function (params) {
                        var arr = params.data && params.data[arrayField];
                        if (!arr) return '';
                        var v = arr[i];
                        return (v === '' || v === null || v === undefined) ? '' : formatter ? formatter(v) : v;
                    },
                };
            });
        };

        return [
            // ── Fixed identity columns ──────────────────────────────────────
            { headerName: "Source",           field: "source",      width: 160, pinned: "left" },
            {
                headerName: "State",
                width: 160,
                pinned: "left",
                valueGetter: function (params) {
                    var code = params.data && params.data.state;
                    if (!code || typeof code !== "string") return code || '';
                    var key = code.trim().toUpperCase();
                    return STATE_CODE_MAP[key] || code.trim();
                },
            },
            { headerName: "City Name",        field: "city",        width: 160, pinned: "left" },
            {
                headerName: "No. of Valid Trips", field: "valid_trips", width: 120, pinned: "left",
                cellStyle: { cursor: 'pointer', color: '#1a73e8', fontWeight: 600 },
            },
            { headerName: "HERO SAP Km",      field: "sap_km",      width: 120, pinned: "left" },

            // ── Avg Trip Distance Km (grouped) ──────────────────────────────
            {
                headerName: "Avg Trip Distance Km",
                children: routeCols("avg_distances", null),
            },

            // ── Route Follower % (grouped) ──────────────────────────────────
            {
                headerName: "Route Follower %",
                children: routeCols("follower_pcts", function (v) {
                    return v !== '' ? v + "%" : '';
                }),
            },

            // ── Route Toll Amount (grouped) ─────────────────────────────────
            {
                headerName: "Route Toll Amount",
                children: routeCols("toll_amounts", null),
            },

            // ── Enmovil Recommended Route (plain column) ────────────────────
            { headerName: "Enmovil Recommend Route", field: "recommended_route", width: 170 },
        ];
    }, [routeLabels]);

    // ── Render ────────────────────────────────────────────────────────────────
    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={function () { setShow(false); }}
            />

            <div className={"dataLoadpage " + loadshow}></div>
            <div className={"overlay-part " + overly} onClick={function () { setLoadshow("show-n"); onCloseSlider(); }}></div>

            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h5>
                                <i className="icon-map cus-i"></i>&nbsp;
                                <span>Route Analysis Dashboard Report</span>
                            </h5>
                        </div>

                        <div className="card-body">

                            <div className="orn-filter-panel p-3">

                                {/* ── Filter row 1: dropdown filters ─────────────── */}
                                <div className="row">

                                    {/* Origin */}
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>Origin</label>
                                        <Select
                                            name="originoption"
                                            value={originoption}
                                            options={originoptions}
                                            onChange={function (v) { setOriginoption(v); }}
                                        />
                                    </div>

                                    {/* Destination */}
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>Destination</label>
                                        <Select
                                            name="destinationoption"
                                            value={destinationoption}
                                            options={destinationOptions}
                                            onChange={function (v) { setDestinationoption(v); }}
                                        />
                                    </div>

                                    {/* Consignee State */}
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>Consignee State</label>
                                        <Select
                                            name="consignee_state"
                                            value={selectedConsState}
                                            options={consignee_state_options}
                                            onChange={function (v) { setSelectedConsState(v); }}
                                        />
                                    </div>

                                    {/* Zone */}
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>Zone</label>
                                        <Select
                                            name="zone"
                                            value={selectedZone}
                                            options={zonesOptions}
                                            onChange={function (v) { setSelectedZone(v); }}
                                        />
                                    </div>

                                    {/* Truck Type */}
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>Truck Type</label>
                                        <Select
                                            name="truck_type"
                                            value={selected_truck_type}
                                            options={truck_types}
                                            onChange={function (v) { setSelectedTruckType(v); }}
                                        />
                                    </div>

                                </div>

                                {/* ── Filter row 2: date filters + toggle + submit ── */}
                                <div className="row ">

                                    {/* Year + Quarter (toggle OFF) OR From Date + To Date (toggle ON) — always on the same row */}
                                    {!use_custom_date_range ? (
                                        <>
                                            <div className="col-xl-2 col-lg-2 form-group">
                                                <label>Year</label>
                                                <Select
                                                    name="year"
                                                    value={selected_year}
                                                    options={YEAR_OPTIONS}
                                                    onChange={function (v) { setSelectedYear(v); }}
                                                />
                                            </div>
                                            <div className="col-xl-2 col-lg-2 form-group">
                                                <label>Quarter</label>
                                                <Select
                                                    name="quarter"
                                                    value={selected_quarter}
                                                    options={QUARTER_OPTIONS}
                                                    onChange={function (v) { setSelectedQuarter(v); }}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-xl-2 col-lg-2 form-group">
                                                <label>From Date</label>
                                                <input
                                                    type="date"
                                                    name="from_date"
                                                    value={from_date}
                                                    onChange={function (e) { setFromDate(e.target.value); }}
                                                    className="form-control orn-date-input"
                                                />
                                            </div>
                                            <div className="col-xl-2 col-lg-2 form-group">
                                                <label>To Date</label>
                                                <input
                                                    type="date"
                                                    name="to_date"
                                                    value={to_date}
                                                    onChange={function (e) { setToDate(e.target.value); }}
                                                    className="form-control orn-date-input"
                                                />
                                            </div>
                                        </>
                                    )}

                                    {/* Custom Date Range toggle */}
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label className="orn-label-spacer">&nbsp;</label>
                                        <div className="orn-toggle-row">
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={use_custom_date_range}
                                                    onChange={toggleCustomDateRange}
                                                />
                                                <span className="switch-state"></span>
                                            </label>
                                            <span className="orn-toggle-text">Custom Date Range</span>
                                        </div>
                                    </div>

                                    {/* Submit */}
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label className="orn-label-spacer">&nbsp;</label>
                                        <button
                                            type="button"
                                            className="btn btn-success orn-submit-btn"
                                            onClick={onSubmit}
                                        >
                                            Submit
                                        </button>
                                    </div>

                                </div>
                            </div>

                            {/* ── Export toolbar ─────────────────────────────── */}
                            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: 10, gap: 8 }}>
                                <button
                                    type="button"
                                    onClick={onExportExcel}
                                    disabled={!rowData.length}
                                    title="Export to Excel"
                                    style={{
                                        display: "flex", alignItems: "center", gap: 6,
                                        padding: "6px 16px", borderRadius: 4, border: "none", cursor: rowData.length ? "pointer" : "not-allowed",
                                        backgroundColor: rowData.length ? "#1d6f42" : "#aaa", color: "#fff",
                                        fontWeight: 600, fontSize: 13, opacity: rowData.length ? 1 : 0.6,
                                        boxShadow: rowData.length ? "0 2px 4px rgba(0,0,0,0.18)" : "none",
                                    }}
                                >
                                    <i className="fa fa-file-excel-o" style={{ fontSize: 15 }}></i>
                                    Export Excel
                                </button>
                                <button
                                    type="button"
                                    onClick={onExportCsv}
                                    disabled={!rowData.length}
                                    title="Export to CSV"
                                    style={{
                                        display: "flex", alignItems: "center", gap: 6,
                                        padding: "6px 16px", borderRadius: 4, border: "none", cursor: rowData.length ? "pointer" : "not-allowed",
                                        backgroundColor: rowData.length ? "#e31837" : "#aaa", color: "#fff",
                                        fontWeight: 600, fontSize: 13, opacity: rowData.length ? 1 : 0.6,
                                        boxShadow: rowData.length ? "0 2px 4px rgba(0,0,0,0.18)" : "none",
                                    }}
                                >
                                    <i className="fa fa-file-text-o" style={{ fontSize: 15 }}></i>
                                    Export CSV
                                </button>
                            </div>

                            {/* ── Grid ───────────────────────────────────────── */}
                            <div className="ag-theme-balham orn-grid-container">
                                <AgGridReact
                                    modules={AllModules}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    rowData={rowData}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    animateRows={true}
                                    sideBar={SIDE_BAR_DEF}
                                    onGridReady={onGridReady}
                                    onCellClicked={onCellClicked}
                                    overlayNoRowsTemplate='<span style="padding:10px;color:#555">Select filters and click Submit to load data.</span>'
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* ── Valid Trips Slider ─────────────────────────────── */}
            <div className={"slide-r " + sliderTranslate} style={{ overflow: "auto" }}>
                <div className="slide-r-title">
                    <h4>
                        {sliderMode === 'map' && (
                            <span
                                className="float-left"
                                style={{ marginLeft: 10, marginRight: 15, cursor: 'pointer' }}
                                onClick={onBackToGrid}
                                title="Back to list"
                            >&larr; Back</span>
                        )}
                        {sliderTitle}
                        <span
                            className="float-right closebtn"
                            style={{ marginRight: 25, cursor: 'pointer' }}
                            onClick={onSliderCloseClick}
                        >X</span>
                    </h4>
                </div>

                <div className="slide-r-body" style={{ position: 'relative' }}>

                    {/* Map — permanently mounted, shown/hidden via CSS display */}
                    <div key="rad-map-view" style={{ display: sliderMode === 'map' ? 'block' : 'none' }}>
                        {mapLegend.length > 0 && (
                            <div className="orn-map-legend">
                                {mapLegend.map(function (g, i) {
                                    return (
                                        <span key={i} className="orn-map-legend-item">
                                            <span className="orn-map-legend-swatch" style={{ background: g.color }}></span>
                                            {g.label}
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                        <div id="radMap" ref={mapDivRef} className="orn-map-canvas"></div>
                    </div>

                    {/* Grid — mounted only when slider is open and in grid mode */}
                    {sliderTranslate !== '' && sliderMode !== 'map' && (
                        <div key="rad-grid-view" className="ag-theme-balham orn-detail-grid">
                            <AgGridReact
                                modules={AllModules}
                                rowData={sliderTrips}
                                defaultColDef={{ sortable: true, filter: true, resizable: true }}
                                pagination={true}
                                paginationPageSize={20}
                                onCellClicked={onTripCellClicked}
                                overlayNoRowsTemplate='<span style="padding:10px;color:#555">No trip records found.</span>'
                                columnDefs={[
                                    {
                                        headerName: "", field: "_rowmap", width: 40, pinned: "left",
                                        cellRenderer: function () {
                                            return '<i class="icofont icofont-map-pins" style="font-size:18px;cursor:pointer;color:#2c7be5;" title="View Route Map"></i>';
                                        },
                                    },
                                    { headerName: "Invoice No",      field: "invoice_no",      width: 130 },
                                    { headerName: "Vehicle No",      field: "vehicle_no",      width: 120 },
                                    { headerName: "Shipment ID",     field: "shipment_id",     width: 140 },
                                    { headerName: "Route Label",     field: "route_label",     width: 100 },
                                    { headerName: "Transporter",     field: "tpt_name",        width: 180 },
                                    { headerName: "Dealer Name",     field: "dl_name",         width: 180 },
                                    { headerName: "Dealer City",     field: "dl_city",         width: 120 },
                                    { headerName: "Dealer State",    field: "dl_state",        width: 100 },
                                    {
                                        headerName: "Trip Start", field: "sl_exit_dt", width: 160,
                                        valueGetter: function (p) { return getHyphenYYYYMMDDHHMMSS(p.data && p.data.sl_exit_dt); },
                                    },
                                    {
                                        headerName: "Trip End", field: "trip_end_time", width: 160,
                                        valueGetter: function (p) { return getHyphenYYYYMMDDHHMMSS(p.data && p.data.trip_end_time); },
                                    },
                                    { headerName: "Distance Km",     field: "ttd_std_km",      width: 110 },
                                    { headerName: "Total Toll Cost", field: "total_toll_cost", width: 120 },
                                    {
                                        headerName: "Is Base Route", field: "is_base_route", width: 110,
                                        valueGetter: function (p) { return p.data && p.data.is_base_route ? 'Yes' : 'No'; },
                                    },
                                ]}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
